enum TextureType {
  RGB = "RGB",
  IR = "IR",
  RTI = "RTI",
  HYPERSPECTRAL = "hyperspectral",
}

export default TextureType;
